export function nav($) {
    initHamburger($);
	initPrimaryNav($);

    $('#nav-search-form').hover(function() {
        $('#nav-search-input').focus();
    });

}

function initHamburger($) {
	$('.hamburger-menu').on('click', function() {
        $('.headroom').removeClass('headroom--pinned');

        if($("#navButtonClose").hasClass('d-none')) {
            $("#navButtonOpen").addClass('d-none');
            $("#navButtonClose").removeClass('d-none');
			$('body').addClass('nav-open');
        } else {
            $("#navButtonClose").addClass('d-none');
            $("#navButtonOpen").removeClass('d-none');
			$('body').removeClass('nav-open');
        }
    });
}

function initPrimaryNav($) {
	// nav activation
	let $nav = $('#primaryNavigation');

	$('.nav-item.has-children > .nav-link', $nav).on('click', function(event) {
		let $item = $(this).closest('.nav-item');
		event.preventDefault();
		$item.toggleClass('show');

		$('.nav-item')
			.not($item)
			.not($item.parents('.nav-item'))
			.removeClass('show');
	});


	// initially show open state
	$('.nav-item.current_page_item', $nav).addClass('show');
	$('.nav-item.current_page_item', $nav).parents('.nav-item').addClass('show');
}